import React from 'react';
import { modDatabase } from 'data/mods';
import { ValueModifierInputProps } from './types';

const ValueModifierInput: React.FC<ValueModifierInputProps> = ({ modifier, onChange }) => {
  const modInfo = modDatabase.mods[modifier.modId];
  
  // Get range values with fallbacks
  const min = modifier.range?.[0] || 0;
  const max = modifier.range?.[1] || 100;
  
  // Make sure the value is defined with proper fallbacks
  const currentValue = modifier.value !== undefined 
    ? modifier.value 
    : (modifier.defaultValue !== undefined ? modifier.defaultValue : min);

  // Handle value change with range validation
  const handleValueChange = (newValue: number) => {
    // Ensure value stays within range
    const clampedValue = Math.min(Math.max(newValue, min), max);
    
    // Call the onChange handler with the new value
    onChange(clampedValue);
  };

  return (
    <div className="bg-gray-700 p-3 rounded">
      <div className="text-white mb-2">
        {modInfo?.description || `Modifier #${modifier.modId}`}
      </div>

      <div className="flex justify-between text-xs text-gray-400 mb-1">
        <span>Min: {min}</span>
        <span>Current: {currentValue}</span>
        <span>Max: {max}</span>
      </div>

      <input
        type="range"
        min={min}
        max={max}
        value={currentValue}
        onChange={(e) => handleValueChange(Number(e.target.value))}
        className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-gray-600"
      />

      <input
        type="number"
        value={currentValue}
        onChange={(e) => handleValueChange(Number(e.target.value))}
        min={min}
        max={max}
        step={1}
        className="w-full p-2 rounded bg-gray-800 text-white mt-2"
        placeholder="Enter value..."
      />
    </div>
  );
};

export default ValueModifierInput;